<!-- ════════════════════════════════════════════════════════════════
     V3 DESIGN — Tab Bar
     ════════════════════════════════════════════════════════════════ -->
<ng-container *ngIf="designVersion === 'v3'">
  <!-- Chevron wrapper — same [left][scrolling tabs][right] structure as
       job-portfolio's V3 bar (classes in _horizontal-tabs.scss). Arrows
       render only when the strip overflows; `scrollContainer12` id reuses
       the component's scrollLeft()/scrollRight() (no clash with the V2
       <ul> below — only one designVersion branch renders). -->
  <div class="jc-v3-tab-bar-wrap">
    <div class="jc-v3-tab-scroll-btn" *ngIf="hasOverflow">
      <div id="candidate_portfolio_v3_scroll_left_button" (click)="scrollLeft()">
        <ng-icon name="tablerChevronLeft"></ng-icon>
      </div>
    </div>
  <div class="jc-v3-tab-bar" id="scrollContainer12">
    <button class="jc-v3-tab-btn" [class.active]="pageName === 'profileSummary'"
      (click)="onChange('profileSummary')">Profile</button>

    <button class="jc-v3-tab-btn" *ngIf="candidateDetails?.createdBy == userId"
      [class.active]="pageName === 'cInvited'" (click)="onChange('cInvited')">Job Invites</button>

    <button class="jc-v3-tab-btn" *ngIf="candidateDetails?.createdBy == userId"
      [class.active]="pageName === 'candidate-requests-received'"
      (click)="onChange('candidate-requests-received')">Resume Requests</button>

    <button class="jc-v3-tab-btn" *ngIf="candidateDetails?.createdBy == userId"
      [class.active]="pageName === 'jobsApplied'" (click)="onChange('jobsApplied')">Applied</button>

    <button class="jc-v3-tab-btn" *ngIf="candidateDetails?.createdBy == userId"
      [class.active]="pageName === 'suggestedJobs'" (click)="onChange('suggestedJobs')">Marketplace Jobs</button>

    <button class="jc-v3-tab-btn" *ngIf="candidateDetails?.createdBy == userId"
      [class.active]="pageName === 'views'" (click)="onChange('views')">Views</button>

    <button class="jc-v3-tab-btn" *ngIf="candidateDetails?.createdBy == userId"
      [class.active]="pageName === 'Clike-like'" (click)="onChange('Clike-like')">Likes</button>

    <button class="jc-v3-tab-btn" *ngIf="candidateDetails?.createdBy == userId"
      [class.active]="pageName === 'candidate-activity'"
      (click)="onChange('candidate-activity')">Event Logs</button>
  </div>
    <div class="jc-v3-tab-scroll-btn" *ngIf="hasOverflow">
      <div id="candidate_portfolio_v3_scroll_right_button" (click)="scrollRight()">
        <ng-icon name="tablerChevronRight"></ng-icon>
      </div>
    </div>
  </div>
</ng-container>

<!-- ════════════════════════════════════════════════════════════════
     V2 DESIGN (existing) — Tab Bar
     ════════════════════════════════════════════════════════════════ -->
<ng-container *ngIf="designVersion !== 'v3'">
<div *ngIf="candidateDetails?.createdBy == userId" (mouseenter)="onMouseEnter1()" (mouseleave)="onMouseLeave1()"
  class="show-hidden-design-left">
  <div *ngIf="showChevron || showChevron1" class="left-scroll-buttons"  style="top: 10px;">
    <div (click)="scrollLeft()">
      <ng-icon name="tablerChevronLeft"></ng-icon>
    </div>
  </div>
</div>

<div class="hpanel br-none">
  <div class="panel-body pad-0 candidate-portfolio-header border-radius-top-left-right-6 border-radius-bottom-left-right-0" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    <ul class="nav navbar-nav menu-scroll-view"
      [ngClass]="{'menu-scroll-view-1': candidateDetails?.createdBy != userId}" id="scrollContainer12">
      <li id="profileSummary" display="dynamic" class="menu-item" [ngClass]="{'active': pageName=='profileSummary'}"
        routerLinkActive="router-link-active" title="Profile" (click)="onChange('profileSummary')">
        <a>
          Profile
        </a>
        <!-- <a>
          Profile Summary
        </a> -->
      </li>
      <!-- <li id="candidateDetails" display="dynamic" class="menu-item" [ngClass]="{'active': pageName=='candidateDetails'}"
        routerLinkActive="router-link-active" title="Details" (click)="onChange('candidateDetails')">
        <a>
          Details
        </a>
      </li> -->
      <li id="cInvited" *ngIf="candidateDetails?.createdBy == userId" [ngClass]="{'active': pageName=='cInvited'}"
        (click)="onChange('cInvited')" display="dynamic" class="menu-item" routerLinkActive="router-link-active"
        title="Job Invites">
        <a> Job Invites </a>
      </li>
      <li id="candidate-requests-received" *ngIf="candidateDetails?.createdBy == userId" [ngClass]="{'active': pageName=='candidate-requests-received'}"
        (click)="onChange('candidate-requests-received')" display="dynamic" class="menu-item"
        routerLinkActive="router-link-active" title="Resume Requests">
        <a>
          Resume Requests
        </a>
      </li>
      <li id="jobsApplied" *ngIf="candidateDetails?.createdBy == userId" display="dynamic" (click)="onChange('jobsApplied')"
        [ngClass]="{'active': pageName=='jobsApplied'}" class="menu-item" routerLinkActive="router-link-active"
        title="Applied">
        <a>
          Applied
        </a>
        <!-- <a>
          Jobs Applied
        </a> -->
      </li>
        <li id="jobsApplied" *ngIf="candidateDetails?.createdBy == userId" display="dynamic" (click)="onChange('suggestedJobs')"
        [ngClass]="{'active': pageName=='suggestedJobs'}" class="menu-item" routerLinkActive="router-link-active"
        title="Marketplace Jobs">
        <a>
          Marketplace Jobs
        </a>
      </li>
      <li id="views" *ngIf="candidateDetails?.createdBy == userId" display="dynamic" (click)="onChange('views')"
        [ngClass]="{'active': pageName=='views'}" class="menu-item" routerLinkActive="router-link-active"
        title="Views">
        <a>
          Views
        </a>
      </li>
      <!-- to be used in the upcoming changes -->
      <!-- <li *ngIf="candidateDetails?.createdBy == userId" display="dynamic" (click)="onChange('documents')"
        [ngClass]="{'active': pageName=='documents'}" class="menu-item" routerLinkActive="router-link-active"
        title="Jobs Applied">
        <a>
          Documents
        </a>
      </li> -->
      <li id="Clike-like" *ngIf="candidateDetails?.createdBy == userId" display="dynamic" (click)="onChange('Clike-like')"
        [ngClass]="{'active': pageName=='Clike-like'}" class="menu-item" routerLinkActive="router-link-active"
        title="Likes">
        <a>
          Likes
        </a>
      </li>
      <li id="candidate-activity" *ngIf="candidateDetails?.createdBy == userId" display="dynamic" (click)="onChange('candidate-activity')"
      [ngClass]="{'active': pageName=='candidate-activity'}" class="menu-item" routerLinkActive="router-link-active"
      title="Event Logs">
      <a>
        Event Logs
      </a>
    </li>
    </ul>
  </div>
</div>

<div *ngIf="candidateDetails?.createdBy == userId" (mouseenter)="onMouseEnter1()" (mouseleave)="onMouseLeave1()"
  class="show-hidden-design-right">
  <div *ngIf="showChevron || showChevron1" class="right-scroll-buttons">
    <div (click)="scrollRight()">
      <ng-icon name="tablerChevronRight"></ng-icon>
    </div>
  </div>
</div>
</ng-container>
